import { useSelector } from 'react-redux'

import cn from 'classnames'

import { tr } from 'mmfintech-commons'
import { extractBankName, extractBankNameDomestic } from 'mmfintech-checkout-commons'

import { ArrowRight } from '@icons'
import { ThreeCircles } from 'react-loader-spinner'
import { SelectBankIcon } from '@components/SelectBank/SelectBankIcon'

import type { SupportedBank } from 'mmfintech-checkout-commons/types'

type SelectBankItemProps = {
  bank: SupportedBank
  selected?: boolean
  onClick: () => void
  'data-test'?: string
}

export const SelectBankItem = (props: SelectBankItemProps) => {
  const { bank, selected, onClick, 'data-test': dataTest } = props

  const checkoutPayFetching = useSelector(({ checkout }) => checkout.checkoutPayFetching)

  return (
    <div
      className={cn('select-bank-item-wrapper', 'custom-radio', { selected, maintenance: bank.underMaintenance })}
      onClick={onClick}
      data-test={dataTest}
    >
      <div className={cn('select-bank-item-content', { selected })}>
        <span className='icon'>
          <SelectBankIcon bank={bank} />
        </span>
        <span className='text'>
          <span className='caption'>{extractBankName(bank)}</span>
          <span>{extractBankNameDomestic(bank)}</span>
          {bank.underMaintenance && (
            <span className='warning'>{tr('CHECKOUT.VOUCHER.BANKS.MAINTENANCE', 'Under maintenance')}</span>
          )}
        </span>
      </div>
      <div className={cn('button-wrapper', { selected })}>
        {selected && checkoutPayFetching ? (
          <ThreeCircles width='3.5rem' height='3.5rem' color='#55419b' />
        ) : (
          <ArrowRight color='#55419b' />
        )}
      </div>
    </div>
  )
}
